import {Component, Injector} from '@angular/core';
import {ColumnType, GeneralListComponent} from "../shared/general-list/general-list.component";
import {ModbusService} from "./modbus.service";
import {ModbusrtuModel} from "../model/modbusrtu.model";

@Component({
    selector: 'app-modbusrtu',
    templateUrl: '../shared/general-list/general-list.component.html',
    standalone: false
})
export class ModbusrtuComponent extends GeneralListComponent {

  constructor(
    injector: Injector,
    private modbusService: ModbusService
  ) {
    super(injector);
    this.showNewBtn = true;
    this.title = this.modbusService.getTranslation("MODBUSRTU");

    this.columns = [
      {id: 'id',label: 'ID', type: ColumnType.Simple},
      {id: 'typeName',label: this.modbusService.getTranslation("TYPE"), type: ColumnType.Simple},
      {id: 'attributeName',label: this.modbusService.getTranslation("ATTRIBUTE"), type: ColumnType.Simple},
      {id: 'measureName',label: this.modbusService.getTranslation("MEASURE"), type: ColumnType.Simple},
      {id: 'multiplier',label: this.modbusService.getTranslation("MULTIPLIER"), type: ColumnType.Simple},
      {id: 'length',label: this.modbusService.getTranslation("LENGTH"), type: ColumnType.Simple},
      {id: 'address',label: this.modbusService.getTranslation("ADDRESS"), type: ColumnType.Simple},
      {id: 'datatype',label: this.modbusService.getTranslation("DATATYPE"), type: ColumnType.Simple},
      {id: 'modified',label: this.modbusService.getTranslation("MODIFIED"), type: ColumnType.Simple},
      {id: 'modifiedBy',label: this.modbusService.getTranslation("MODIFIEDBY"), type: ColumnType.Simple},
      {id: 'enabled',label: this.modbusService.getTranslation("IS_ENABLED"), type: ColumnType.Boolean},
      {id: 'action', label: 'edit', type: ColumnType.Action}
    ];
  }

  fetchItems() {
    this.modbusService.getItems().subscribe((resp:any) => {
      if (resp) {
        this.items = resp.map(r => new ModbusrtuModel(r));
        this.dataSource.data = this.items;
      }
    })
  }
}
